import { useTranslation } from "react-i18next";
import type { GuestSelectLabels } from "./GuestSelect";

export const useGuestSelectLabels = (categoryTitle?: string): GuestSelectLabels => {
  const { t } = useTranslation();
  const categoryHint = categoryTitle
    ? t("guest_select.max_limit_hint.category", { categoryTitle })
    : undefined;
  return {
    adults: t("guest_select.adults"),
    teenagers: t("guest_select.teenagers"),
    children: t("guest_select.children"),
    infants: t("guest_select.infants"),
    child: t("guest_select.child"),
    infant: t("guest_select.infant"),
    age: t("guest_select.age"),
    adultsSubtitle: t("guest_select.adults_subtitle"),
    teenagersSubtitle: t("guest_select.teenagers_subtitle"),
    childrenSubtitle: t("guest_select.children_subtitle"),
    infantsSubtitle: t("guest_select.infants_subtitle"),
    fromAge: (age) => t("guest_select.from_age", { age }),
    ageRange: (minAge, maxAge) =>
      t("guest_select.age_range", { minAge, maxAge }),
    ageLabel: (age) => t("guest_select.age_years", { count: age }),
    minGuests: (count) => t("guest_select.min_guests", { count }),
    maxLimitHint: {
      adults: categoryHint ?? t("guest_select.max_limit_hint.adults"),
      teenagers: categoryHint ?? t("guest_select.max_limit_hint.teenagers"),
      children: categoryHint ?? t("guest_select.max_limit_hint.children"),
      infants: categoryHint ?? t("guest_select.max_limit_hint.infants"),
      total: categoryHint ?? t("guest_select.max_limit_hint.total"),
    },
  };
};
